module.exports = __webpack_public_path__ + "static/media/secure_data.e4531902.svg";